import { FC, useEffect, useState } from "react";
import styles from "./index.module.css";

import { floatToPriceWithoutSpace } from "../../functions/price_functions";
import { Input } from "../inputs/inputs";
import { useOrder } from "../../hooks/useOrder";
import { usePluginspace } from "../../hooks/usePluginspace";
import { LocationType } from "../../contexts/PluginspaceContext";
import api from "../../services/api";
import { cepNoMask } from "../../functions/mask";
import { ModalSelectAddress } from "../ModalSelectAddress";
import {
  ModalCreateAddress,
  ModalCreateAddressNoLogin,
  ModalEditAddress,
} from "../ModalCreateAddress";
import { FrenetDeliveryMethodType } from "../../contexts/OrderContext";
import { useSellerCart } from "../../contexts/sellerCartContext";
import useCart from "../../contexts/cartContext/cartContext";
import { useOrderMetaData } from "../../contexts/orderMetaDataContext/orderMetaDataContext";

type StoresType = {
  id: number;
  name: string;
  city: string;
  district: string;
  street: string;
  number: string;
  currentBalance: number;
  distance: string;
};

type ModalWithdrawalProps = {
  isOpen: boolean;
  setIsOpen: (value: boolean) => void;
  backgroundButton?: string;
  fontButton?: string;
  stores: Array<StoresType>;
};

type AddressLocationType = {
  cep: string;
  city: string;
  district: string;
  extra: string;
  number: string;
  state: string;
  street: string;
};

type LocationResponseType = {
  address: AddressLocationType;
  type: string;
  name: string;
  code: string;
};

interface CustomerAddress {
  id: number;
  customerId: number;
  typeAddress: string;
  street: string;
  extra: string;
  number: string;
  district: string;
  city: string;
  reference: string;
  state: string;
  zipCode: string;
  ibgeCode: string;
  latlng: Latlng;
  placeId: string;
  created: string;
  updated: string;
}

interface Latlng {
  lat: number;
  lng: number;
}

type Props = {
  deliveryActive: boolean;
  withDrawValue: number;
  deliveryDrawValue: number;
  setCep: (value: string) => void;
  cep: string;
  setTypeFreight: (value: string) => void;
  setFreightFind: (value: number) => void;
  typeFreight: string;
  customerAddresses: any[];
  findCepDeliveryCustomerCep: (cep: string) => any;
  setFindCep: (value: boolean) => void;
  setAllcustomerAddresses: (value: any) => void;
  findCep: boolean;
  shouldUpdate: boolean;
  customerName: string;
  customerPhone: string;
  customerInfoComplete: any;
  frenetMethods: FrenetDeliveryMethodType[];
  config: any;
};

type address = {
  id: number;
  customerId: number;
  typeAddress: string;
  street: string;
  number: string;
  district: string;
  complement: string;
  city: string;
  state: string;
  zipCode: string;
  ibgeCode: string;
  latlng?: any;
  placeId?: string;
  created?: string;
  updated?: string;
};

const ChooseAddressOrder: FC<Props> = ({
  deliveryActive,
  setFindCep,
  customerInfoComplete,
  customerName,
  customerPhone,
  findCep,
  findCepDeliveryCustomerCep,
  withDrawValue,
  deliveryDrawValue,
  setCep,
  cep,
  setTypeFreight,
  setFreightFind,
  typeFreight,
  customerAddresses,
  shouldUpdate,
  setAllcustomerAddresses,
  frenetMethods,
  config,
}) => {
  const { getLocations, pluginspace } = usePluginspace();
  const [locations, setLocations] = useState<Array<LocationType>>([]);
  const [customerAddressesSelected, setCustomerAddressesSelected] =
    useState<any>();
  const [selectAddressOpen, setSelectAddressOpen] = useState(false);
  const sellerCartContext = useSellerCart();

  const { setFreightCost } = useCart();
  const {setFreightCost: setFreightCostOrderMetaData, setFreightType} = useOrderMetaData()
  const orderMetaData = useOrderMetaData()


  // Editar Endereço
  const [editAddressOpen, setEditAddressOpen] = useState(false);
  const [editAddressData, setEditAddressData] = useState<address | null>(null);

  //modal de criar e selecionar address
  const [createAddressOpen, setCreateAddressOpen] = useState(false);
 
  const [labelFree, setLabelFree] = useState("");

  const hasDelivery = locations.find((loc) => loc.code === "delivery")
  const hasWithdraw = locations.find((loc) => loc.code === "withdraw")

  useEffect(() => {
    mountChooseAddress();
    getConfigLabelFree();
    if (shouldUpdate) {
      setWithdrawLocation();
    }
  }, []);

  useEffect(() => {
    setCustomerAddresses();
  }, [customerAddresses]);

  async function mountChooseAddress() {
    try {
      const loc = await getLocations();

      setLocations(loc);
    } catch (error) {
      console.log(error);
    }
  }

  async function getConfigLabelFree() {
    if (config?.content?.pdv?.customDeliveryFreeLabel)
      setLabelFree(config.content.pdv.customDeliveryFreeLabel);
  }

  async function setWithdrawLocation() {
 
    orderMetaData.setOrderType("withdraw");
    const store = pluginspace.address;
    const newLocation = await getLocations();
    const loc = newLocation.find(
      (location: LocationResponseType) => location.type == "address"
    );
    const locationWithdraw = newLocation.find(
      (location: LocationResponseType) => location.code == "withdraw"
    );

    if (locationWithdraw && loc) {
      orderMetaData.setFreightCost(withDrawValue);
      setFreightCost(withDrawValue);
      setTypeFreight("withdraw"); 
      orderMetaData.setDeliveryAddress({
        address: loc.address.street,
        cep: loc.cep,
        state: loc.address.state,
        city: loc.address.city,
        complement: loc.address.extra,
        district: loc.address.district,
        name: store?.name,
        number: loc.address.number,
        reference: "",
        otherPersonToWithdrawal: null,
      });
      orderMetaData.setLocationId(locationWithdraw.id);
    }
  }

  async function setDeliveryLocaition(
    valueDelivery?: string,
    priceFreight?: number,
    frenetItem?: FrenetDeliveryMethodType
  ) {
    try {
      
      orderMetaData.setOrderType("delivery");
      const newLocation = await getLocations();
      const locationWithdraw = newLocation.find(
        (location: LocationResponseType) => location.code == "delivery"
      );
      let value = deliveryDrawValue;
      if (!findCep) {
        value = await findCepDeliveryCustomerCep(
          customerAddressesSelected.zipCode
        );
      }
      setTypeFreight(valueDelivery ? valueDelivery : "delivery");
      setFreightFind(priceFreight ? priceFreight : value);

      orderMetaData.setFreightCost(priceFreight ? priceFreight : value);
      setFreightCost(priceFreight ? priceFreight : value);
      orderMetaData.setDeliveryAddress({
        address: customerAddressesSelected.street,
        cep: customerAddressesSelected.zipCode,
        state: customerAddressesSelected.state,
        city: customerAddressesSelected.city,
        complement: customerAddressesSelected.complement,
        extra: customerAddressesSelected.extra,
        district: customerAddressesSelected.district,
        name: customerName,
        telephone: customerPhone,
        typeAddress: customerAddressesSelected.typeAddress,
        number: customerAddressesSelected.number,
        reference: customerAddressesSelected.reference
          ? customerAddressesSelected.reference
          : "",
        otherPersonToWithdrawal: null,
        frenet: frenetItem,
      });
      orderMetaData.setLocationId(locationWithdraw.id);
    } catch (error) {
      console.log(error);
    }
  }

  async function setDeliveryLocation(
    customerAddressesByModal: any,
    valueFindedCep?: any
  ) {
    try {
 
      orderMetaData.setOrderType("delivery");
      const newLocation = await getLocations();
      const locationWithdraw = newLocation.find(
        (location: LocationResponseType) => location.code == "delivery"
      );
      let value =
        valueFindedCep || valueFindedCep === 0
          ? valueFindedCep
          : await findCepDeliveryCustomerCep(customerAddressesByModal.zipCode);


      const sellerCartFreight = sellerCartContext.getSellerCartFreight();
      if (sellerCartFreight != null) {
        value = sellerCartFreight
      }

      setTypeFreight("delivery");
      setFreightFind(value);

      orderMetaData.setFreightCost(value);
      setFreightCost(value);
      orderMetaData.setDeliveryAddress({
        address: customerAddressesByModal.street,
        cep: customerAddressesByModal.zipCode,
        state: customerAddressesByModal.state,
        city: customerAddressesByModal.city,
        complement: customerAddressesByModal.complement,
        district: customerAddressesByModal.district,
        name: customerName,
        telephone: customerPhone,
        typeAddress: customerAddressesByModal.typeAddress,
        number: customerAddressesByModal.number,
        extra: customerAddressesByModal.extra,
        reference: customerAddressesByModal.reference
          ? customerAddressesByModal.reference
          : "",
        otherPersonToWithdrawal: null,
      });
      orderMetaData.setLocationId(locationWithdraw.id);
    } catch (error) { }
  }

  function setCustomerAddresses() {
    try {
      if (customerAddresses.length) {
        if (cep) {
          setCustomerAddressesSelected(
            customerAddresses.find((el) => el.zipCode === cep)
          );
        } else {
          setCustomerAddressesSelected(
            customerAddresses.filter(
              (address: any) => address.extra && address.extra != ""
            )[0]
          );
        }
      }
    } catch (err) {
      console.log(err);
    }
  }

  async function setAddressDeliveryByModal(cep: string) {
    try {
      const value = await findCepDeliveryCustomerCep(cep);
      const find = customerAddresses.find((address) => address.zipCode === cep);
      if (find) {
        await setDeliveryLocation(find, value || value === 0 ? value : null);
      }
    } catch (error) {
      console.log(error);
    }
  }

  return (
    <div className={styles.content}>
      <h4 className={styles.content_title}>Escolha a forma de entrega</h4>
      {hasDelivery && (
        <>
          {!frenetMethods.length && !findCep && (
            <span
              style={{ padding: "8px 0", color: "red", fontSize: "0.875rem" }}
            >
              Entrega indisponível para este endereço
            </span>
          )}
          {frenetMethods &&
            frenetMethods.map((frenetMethod) => (
              <Input
                inputAttr={{
                  type: "radio",
                }}
                name={frenetMethod.ServiceCode}
                label={`${frenetMethod.ServiceDescription
                  ? frenetMethod.ServiceDescription
                  : frenetMethod.Carrier
                  } (${frenetMethod.DeliveryTime} ${parseInt(frenetMethod.DeliveryTime) > 1 ? "dias" : "dia"
                  } úteis): ${floatToPriceWithoutSpace(
                    parseFloat(frenetMethod.ShippingPrice)
                  )}`}
                checked={typeFreight === `delivery-${frenetMethod.ServiceCode}`}
                change={() =>
                  setDeliveryLocaition(
                    `delivery-${frenetMethod.ServiceCode}`,
                    parseFloat(frenetMethod.ShippingPrice),
                    frenetMethod
                  )
                }
              />
            ))}
          {deliveryActive && findCep && (
            <Input
              inputAttr={{
                type: "radio",
              }}
              name="freghtType"
              label={`${locations.find((loc) => loc.code === "delivery")?.name
                }: ${deliveryDrawValue === 0 && labelFree
                  ? labelFree
                  : floatToPriceWithoutSpace(deliveryDrawValue)
                }`}
              checked={typeFreight === "delivery"}
              change={(value: string) => {
                setDeliveryLocaition();
              }}
            />
          )}
          {/* Campo usado para quando o Cliente selecionou um endereço... */}
          {customerAddressesSelected && (
            <div
              className={styles.address_selected}
              style={{ marginBottom: "5px" }}
            >
              <div>
                <h5
                  style={{
                    fontSize: "1rem",
                    paddingBottom: "0.4rem",
                    fontWeight: "bold",
                    color: "#333",
                  }}
                >
                  Enviar no meu endereço
                </h5>
              </div>
              <div
                className={styles.address_selected_info}
                style={{ paddingBottom: "0.4rem" }}
              >
                {/* <span>{customerName}</span> */}
                {/* <span>{customerAddressesSelected.extra}</span> */}
                <span>
                  {customerAddressesSelected.street} ,{" "}
                  {customerAddressesSelected.number}
                </span>
                <span>
                  {customerAddressesSelected.reference
                    ? `${customerAddressesSelected.reference} - `
                    : ""}
                  {customerAddressesSelected.district}
                </span>
                <span>{customerAddressesSelected.extra}</span>
                
              </div>
              <div
                style={{
                  borderTop: "1px solid #e0e0e0",
                  textAlign: "left",
                  paddingBottom: "0.4rem",
                  margin: "0 -8px",
                }}
              ></div>
              <div
                className={styles.address_new}
                style={{ paddingBottom: "0.4rem" }}
              >
                <span
                  onClick={() => setSelectAddressOpen(true)}
                  style={{ cursor: "pointer" }}
                >
                  Editar ou escolher outro endereço
                </span>
              </div>
            </div>
          )}
         
        </>
      )}
      {hasWithdraw && (
        <Input
          inputAttr={{
            type: "radio",
          }}
          name="freghtType"
          label={`Retirada na loja: ${withDrawValue === 0 && labelFree
            ? labelFree
            : floatToPriceWithoutSpace(withDrawValue)
            }`}
          checked={typeFreight === "withdraw"}
          change={async (value: string) => {
            setTypeFreight("withdraw");
            setFreightFind(withDrawValue);
            await setWithdrawLocation();
          }}
        />
      )}

      <ModalCreateAddressNoLogin
        isOpen={createAddressOpen}
        setIsOpen={setCreateAddressOpen}
        setAddressOrder={setCustomerAddressesSelected}
        verifyAddress={findCepDeliveryCustomerCep}
        setCepList={setCep}
        searchCep={cep}
        setAllAddress={setAllcustomerAddresses}
        allAddress={customerAddresses}
        customerInfoComplete={customerInfoComplete}
      />
      <ModalSelectAddress
        isOpen={selectAddressOpen}
        setIsOpen={setSelectAddressOpen}
        addresses={customerAddresses}
        setAddress={setCustomerAddressesSelected}
        setCep={setCep}
        verifyAddress={setAddressDeliveryByModal}
        setCreateAddressOpen={setCreateAddressOpen}
        setEditAddressOpen={setEditAddressOpen}
        setEditAddressData={setEditAddressData}
        setAllAddresses={setCustomerAddresses}
        setAllAddress={setAllcustomerAddresses}
      />
      {editAddressData && (
        <ModalEditAddress
          isOpen={editAddressOpen}
          setIsOpen={setEditAddressOpen}
          address={editAddressData}
          setAllAddress={setAllcustomerAddresses}
          allAddress={customerAddresses}
          verifyAddress={findCepDeliveryCustomerCep}
          setCepList={setCep}
        />
      )}
    </div>
  );
};

export { ChooseAddressOrder };
